import styled from 'styled-components';
import { MobileModalContent, MobileModalLayout, ModalBackground, ModalFooter } from 'components/Modal/ModalForms';
import MobileBasicButton from 'components/Buttons/MobileBasicButton';
import { BackgroundColor, BorderColor } from 'styles/Global/colorSemantic';
import { MouseEvent } from 'react';
import { Body1Bold, Body3Medium } from 'styles/Global/typography';
import { Radius } from 'styles/Global/objectStyles';

interface MobileAlertDialogPCInfoProps {
    firstTitle: string;
    secondTitle: string;
    firstContent: string;
    secondContent: string;
    button: string;
    clickButton: () => void;
    info: string;
}
export const MobileAlertDialogPCInfo = ({ firstTitle, secondTitle, firstContent, secondContent, button, clickButton, info }: MobileAlertDialogPCInfoProps) => {
    const handleBackgroundClick = (e: MouseEvent) => {
        // 클릭된 요소가 배경 자체인 경우에만 닫기
        if (e.target === e.currentTarget) {
            clickButton();
        }
    };

    return (
        <ModalBackground $type='mobile' onClick={handleBackgroundClick}>
            <MobileModalLayout $gap='16px' $maxWidth='340px'>
                <ModalTitleAndContentContainer>
                    <ColumnWrapper>
                        <Title>{firstTitle}</Title>
                        <Title>{secondTitle}</Title>
                    </ColumnWrapper>
                    <ColumnWrapper>
                        <MobileModalContent>{firstContent}</MobileModalContent>
                        <MobileModalContent>{secondContent}</MobileModalContent>
                    </ColumnWrapper>
                </ModalTitleAndContentContainer>
                <Container>
                    <InfoText>{info}</InfoText>
                </Container>
                <ModalFooter $marginTop='4px'>
                    <MobileBasicButton $width='100%' $height='52px' onClick={clickButton} $type='fill'>
                        {button}
                    </MobileBasicButton>
                </ModalFooter>
            </MobileModalLayout>
        </ModalBackground>
    );
};

const ColumnWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const ModalTitleAndContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 10px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: ${Radius.radius_8};
    padding: 14px 16px;
    gap: 6px;
    background-color: ${BackgroundColor.color_background_disabled};
    border: 1px solid ${BorderColor.color_border_neutral};
`;

const Title = styled(Body1Bold)``;

const InfoText = styled(Body3Medium)``;
